import EquipmentsPage from "../../shared-pages/manufacturer/EquipmentsPage";

const AreaEquipmentsPage = ({ match }) => {
  const { id } = match.params;

  return <EquipmentsPage manufacturerId={id} url={match.url} entityName="area" />;
};

export default AreaEquipmentsPage;
